export enum VersionStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published'
}

export enum VersionType {
  MAJOR = 'major',
  MINOR = 'minor',
  PATCH = 'patch'
}